import React from "react";
import {
  Show,
  DateField,
  NumberField,
  TextField,
  SimpleShowLayout
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import OutgoingButton from "../../components/createOutgoingMaterialButton";
import FileDownload from "../../components/fileDownload";

const styles = {
  card: {
    boxShadow: "none"
  }
};

function IncomingPanel(props) {
  return (
    <Grid container spacing={24}>
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <Show {...props} title=" ">
          <SimpleShowLayout>
            <TextField source="chamber" label="Chamber" />
            <TextField source="cell_number" label="Cell No." />
            <TextField source="vehicle_number" label="Vehicle No." />
          </SimpleShowLayout>
        </Show>
      </Grid>
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <Show {...props} title=" ">
          <SimpleShowLayout>
            <TextField source="invoice_number" label="Invoice No." />
            <DateField source="invoice_date" label="Invoice Date" />
          </SimpleShowLayout>
        </Show>
      </Grid>
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <Show {...props} title=" ">
          <SimpleShowLayout>
            <NumberField source="shortage_of_bags" label="Shortage of Bags" />
            <TextField source="comments" label="Comments" />
          </SimpleShowLayout>
        </Show>
      </Grid>
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <Show {...props} title=" ">
          <SimpleShowLayout>
            <FileDownload
              size="small"
              source="invoice_img"
              label="Invoice Image"
            />
            <FileDownload
              size="small"
              source="waybridge_img"
              label="Waybridge Image"
            />
            <FileDownload size="small" source="other_img" label="Other Image" />
            <OutgoingButton onClick={() => {}} />
          </SimpleShowLayout>
        </Show>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(IncomingPanel);
